import { ModuleStringsProvider } from '@platform/modularity/ModuleStringsProvider';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { NewRecordDialog } from '@platform/engine/form/NewRecordDialog';
import { BulkDialog } from '@platform/engine/list/BulkDialog';
import { useNewRecordPreset } from '@platform/engine/list/create/useNewRecordPreset';
import { PageFrame } from '@platform/engine/list/header/PageFrame';
import { ignoresMenuFilter } from '@platform/engine/list/listHeading';
import { RecordListContent } from '@platform/engine/list/RecordListContent';
import { ViewSettingsDrawer } from '@platform/engine/list/savedViews/ViewSettingsDrawer';
import { DeleteSelectedDialog } from '@platform/engine/list/toolbar/DeleteSelectedDialog';
import { useCanExport } from '@platform/engine/list/toolbar/useCanExport';
import { DesignListHead } from './DesignListHead';
import type { IDesignListBodyProps } from './IDesignListBodyProps';
import { useDesignList } from './useDesignList';

/**
 * Сторінка розділу «Проєктування» зі списком записів бізнес-аналізу (прототип v4: функції, мотивація, сторони й потреби, шляхи, сценарії,
 * вимоги модуля): заголовок розділу, рядок фільтрів і панель дій, тіло списку з усіма поданнями; діалоги створення (вид і модуль задано, «+» доріжки дошки додає значення доріжки),
 * масової зміни статусу, видалення та «Налаштування подання». Рядки підписано рядками пакета бізнес-аналізу.
 */
export function DesignListBody({ ws, module, rt, entry, preset, createText, crumbs, title, showColumn, kinds = [] }: IDesignListBodyProps) {
  const strings = useModuleStrings(module.module.key);
  const { model, actions, confirm, settings, empty, createKind } = useDesignList(ws, module, rt, entry, preset, createText, showColumn);
  const canExport = useCanExport(ws);
  const lane = useNewRecordPreset();
  const initial = { ...preset, ...(lane ?? {}) };
  const head = (
    <>
      {title}
      <DesignListHead model={model} actions={actions} createText={createText} views={{ onEdit: settings.onEdit, onNew: settings.onNew }}
        createKinds={kinds.map((k) => ({ key: k.value, label: k.label, onSelect: () => createKind(k.value) }))} />
    </>
  );
  return (
    <ModuleStringsProvider strings={strings}>
      <PageFrame crumbs={crumbs} head={head}>
        <RecordListContent model={model} actions={actions} canExport={canExport} unfiltered={ignoresMenuFilter(model.state.view)} empty={empty} />
      </PageFrame>
      <NewRecordDialog key={JSON.stringify(initial)} ws={ws} module={module} rt={rt} initialValues={initial} />
      <BulkDialog model={model} />
      {confirm.open && <DeleteSelectedDialog count={confirm.count} busy={actions.busy} onCancel={confirm.cancel} onConfirm={() => void confirm.run()} />}
      {settings.open && (
        <ViewSettingsDrawer ws={ws} rt={rt} view={settings.open.view} initial={settings.open.initial} onClose={settings.close}
          onSaved={settings.onSaved} onDeleted={settings.onDeleted} />
      )}
    </ModuleStringsProvider>
  );
}
